import { render } from "./TransactionInventoryDetail.vue?vue&type=template&id=7328a890&scoped=true"
import script from "./TransactionInventoryDetail.vue?vue&type=script&lang=js"
export * from "./TransactionInventoryDetail.vue?vue&type=script&lang=js"

import "./TransactionInventoryDetail.vue?vue&type=style&index=0&id=7328a890&scoped=true&lang=css"
import "./TransactionInventoryDetail.vue?vue&type=style&index=1&id=7328a890&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7328a890"]])

export default __exports__